var _path;
import * as React from "react";
var SvgFavorite = function SvgFavorite(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.289 8.893-6.595-.958-2.949-5.977a.835.835 0 0 0-1.49 0L8.306 7.935l-6.595.958a.83.83 0 0 0-.46 1.419l4.772 4.652-1.127 6.57a.83.83 0 0 0 1.205.875l5.9-3.102 5.898 3.102a.83.83 0 0 0 1.205-.875l-1.127-6.57 4.772-4.652a.83.83 0 0 0 .241-.476.828.828 0 0 0-.701-.943Zm-6.32 5.416.938 5.463L12 17.195l-4.907 2.58.938-5.463-3.969-3.87 5.486-.798L12 4.675l2.452 4.97 5.486.797-3.969 3.867Z"
  })));
};
export default SvgFavorite;